import { render, staticRenderFns } from "./msjSecretario.vue?vue&type=template&id=23e21433&scoped=true"
import script from "./msjSecretario.vue?vue&type=script&lang=js"
export * from "./msjSecretario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e21433",
  null
  
)

export default component.exports